import { trainersApi } from "api/trainers/trainersApi";
import { TrainerApi } from "api/types";
import { useCallback, useEffect, useState } from "react";

export const useTrainer = (trainerId?: number | string) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<TrainerApi | undefined>(undefined);

  const fetchTrainer = useCallback(async () => {
    if (!trainerId) {
      console.error("Trainer id not found.");
      setLoading(false);
      return;
    }
    try {
      const res = await trainersApi.fetchById(Number(trainerId));
      setData(res.data);
    } catch (error) {
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [trainerId]);

  useEffect(() => {
    fetchTrainer();
  }, [fetchTrainer]);

  return { loading, data, refetch: fetchTrainer };
};
